module.exports = __webpack_public_path__ + "static/img/10.0dd3e11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/10.png
// module id = bp4a
// module chunks = 0